var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main"},[_c('div',{attrs:{"id":"container"}}),_c('el-button',{attrs:{"loading":_vm.loading,"type":"primary"},on:{"click":_vm.submit}},[_vm._v("保存")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }